import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.25C6.615 2.25 2.25 6.615 2.25 12C2.25 17.385 6.615 21.75 12 21.75C17.385 21.75 21.75 17.385 21.75 12C21.75 6.615 17.385 2.25 12 2.25ZM16.28 12.53C16.4205 12.3894 16.4993 12.1988 16.4993 12C16.4993 11.8012 16.4205 11.6106 16.28 11.47L13.28 8.47C13.2113 8.39631 13.1285 8.33721 13.0365 8.29622C12.9445 8.25523 12.8452 8.23318 12.7445 8.23141C12.6438 8.22963 12.5438 8.24816 12.4504 8.28588C12.357 8.3236 12.2722 8.37974 12.201 8.45096C12.1297 8.52218 12.0736 8.60701 12.0359 8.7004C11.9982 8.79379 11.9796 8.89382 11.9814 8.99452C11.9832 9.09522 12.0052 9.19454 12.0462 9.28654C12.0872 9.37854 12.1463 9.46134 12.22 9.53L13.94 11.25H8.25C8.05109 11.25 7.86032 11.329 7.71967 11.4697C7.57902 11.6103 7.5 11.8011 7.5 12C7.5 12.1989 7.57902 12.3897 7.71967 12.5303C7.86032 12.671 8.05109 12.75 8.25 12.75H13.94L12.22 14.47C12.1463 14.5387 12.0872 14.6215 12.0462 14.7135C12.0052 14.8055 11.9832 14.9048 11.9814 15.0055C11.9796 15.1062 11.9982 15.2062 12.0359 15.2996C12.0736 15.393 12.1297 15.4778 12.201 15.549C12.2722 15.6203 12.357 15.6764 12.4504 15.7141C12.5438 15.7518 12.6438 15.7704 12.7445 15.7686C12.8452 15.7668 12.9445 15.7448 13.0365 15.7038C13.1285 15.6628 13.2113 15.6037 13.28 15.53L16.28 12.53Z"
        fill={colorValue}
      />
    </svg>
  );
};
